import { AuthenticationService } from 'src/app/auth/_services';
import { AlertComponent } from './alert/alert.component';
import { Component, OnInit, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SambaUploderService } from 'src/app/pages/gestao/content/shared/file/samba-uploader/samba-uploader.service';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit {
  @Output() logout = new EventEmitter<string>();
  @Input() expires: number;
  
  private timer: string;
  private isInactive: boolean;
  private userActivity: any;
  private userInactive: Subject<any> = new Subject();
  private sessionActivity: any;
  private sessionInactive: Subject<any> = new Subject();

  constructor(
    public dialog: MatDialog,
    private sambaUploaderService: SambaUploderService,
    private authenticationService: AuthenticationService
  ) {
    this.timer = '';
    this.isInactive = false;
    this.userInactive.subscribe(() => this.isInactive = true);
    this.setTimeout();
    this.sessionState();
  }

  ngOnInit() {
    if (this.expires) {
      this.start();
    }
  }

  /**
   * Starts countdown timer.
   */
  start() {
    const interval = setInterval(() => {
      this.expires--;
      this.timer = this.transform(this.expires);
      const isUploading = this.sambaUploaderService.get();

      if (!this.isInactive && !isUploading && this.timer === '00:05:00') {
        this.alert();
      } else if (isUploading && this.timer === '00:05:00') {
        this.authenticationService.refresh().subscribe(response => {
          setTimeout(() => {
            const currentUser = this.authenticationService.currentUserValue;
            const endDateTime = new Date(currentUser.expires);
            const initialDateTime = new Date();

            this.expires =  (endDateTime.getTime() - initialDateTime.getTime())/1000;
            clearInterval(interval);
            this.start();
          }, 1000);
        });
      } else if (this.expires <= 0) {
        clearInterval(interval);
        this.logout.next();
      }
    }, 1000);
  }

  /**
   * Opens a modal to inform that the session time will expire.
   */
  alert(): void {
		this.dialog.open(AlertComponent, {
			width: '620px',
			disableClose: true
		});
	}

  /**
   * Formats a number to 'hh:mm:ss'.
   * @param value The value to transform.
   */
  transform(value: number): string {
    return new Date(value * 1000).toISOString().substr(11, 8);
  }

  /**
   * Detects user and session inactivity.
   */
  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 1000);
    this.sessionActivity = setTimeout(() => this.sessionInactive.next(undefined), 1800000);
  }

  /**
   * Logouts session if it's inactive;
   */
  sessionState() {
    this.sessionInactive.subscribe(() => {
      const url = window.location.pathname;
      const isUploading = this.sambaUploaderService.get();
      if (!isUploading) {
        this.authenticationService.postLastUrl(url).subscribe();
        this.logout.next();
      }
    });
  }

  @HostListener('unloaded')
  ngOnDestroy() {
    this.expires = 0;
  }

  /**
   * Listens user mouse move.
   */
  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    clearTimeout(this.sessionActivity);
    this.isInactive = false;
    this.setTimeout();
  }
}
